import { keyframes } from '@mui/material';

const LogoLoaderKeyframes = keyframes`
  0%   { opacity: 0.5;  filter: drop-shadow(0px 0px 2px rgba(255,255,255,0)) }
  50%  { opacity: 0.9;  filter: drop-shadow(0px 0px 4px rgba(255,255,255,10)) }
  100% { opacity: 0.5;  filter: drop-shadow(0px 0px 2px rgba(255,255,255,0)) }
`;

export const LogoLoaderAnimation = `${LogoLoaderKeyframes} 3s infinite linear`;
